import { create } from "zustand";
import { devtools } from "zustand/middleware";

type TFirstBillingModalState = {
  isModalOpen: boolean;
};

type TFirstBillingModalStore = TFirstBillingModalState & {
  setIsModalOpen: (value: boolean) => void;
};

const initialFirstBillingModalState: TFirstBillingModalState = {
  isModalOpen: false,
};

export const useFirstBillingModalStore = create<TFirstBillingModalStore>()(
  devtools(set => ({
    ...initialFirstBillingModalState,
    setIsModalOpen: (value) => {
      set({
        isModalOpen: value,
      });
    },
  })),
);
